var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15697_5028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 4.81937C1.8335 3.17032 3.26992 1.8335 5.04183 1.8335C6.81374 1.8335 8.25016 3.17032 8.25016 4.81937C8.25016 6.4555 7.22617 8.36471 5.62853 9.04746C5.25609 9.20662 4.82757 9.20662 4.45513 9.04746C2.85749 8.36471 1.8335 6.4555 1.8335 4.81937Z",
    stroke: "#949494",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.8194C13.75 14.1703 15.1864 12.8335 16.9583 12.8335C18.7302 12.8335 20.1667 14.1703 20.1667 15.8194C20.1667 17.4555 19.1427 19.3647 17.545 20.0475C17.1726 20.2066 16.7441 20.2066 16.3716 20.0475C14.774 19.3647 13.75 17.4555 13.75 15.8194Z",
    stroke: "#949494",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 16.0417C17.8748 16.5479 17.4644 16.9583 16.9582 16.9583C16.4519 16.9583 16.0415 16.5479 16.0415 16.0417C16.0415 15.5354 16.4519 15.125 16.9582 15.125C17.4644 15.125 17.8748 15.5354 17.8748 16.0417Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 5.04167C5.95833 5.54793 5.54793 5.95833 5.04167 5.95833C4.53541 5.95833 4.125 5.54793 4.125 5.04167C4.125 4.53541 4.53541 4.125 5.04167 4.125C5.54793 4.125 5.95833 4.53541 5.95833 5.04167Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 3.5835C10.4479 3.5835 10.0002 4.03121 10.0002 4.5835C10.0002 5.13578 10.4479 5.5835 11.0002 5.5835V3.5835ZM11.0002 17.4168L11.7073 18.1239C12.0978 17.7334 12.0978 17.1002 11.7073 16.7097L11.0002 17.4168ZM15.772 7.96354L16.3089 8.8072L15.772 7.96354ZM6.22833 14.0368L6.76521 14.8804H6.76521L6.22833 14.0368ZM10.3323 15.3347C9.94174 14.9442 9.30858 14.9442 8.91805 15.3347C8.52753 15.7252 8.52753 16.3584 8.91805 16.7489L10.3323 15.3347ZM8.91805 18.0847C8.52753 18.4752 8.52753 19.1084 8.91805 19.4989C9.30858 19.8895 9.94174 19.8895 10.3323 19.4989L8.91805 18.0847ZM14.7877 3.5835H11.0002V5.5835H14.7877V3.5835ZM11.0002 16.4168H7.2126V18.4168H11.0002V16.4168ZM15.2351 7.11988L5.69146 13.1931L6.76521 14.8804L16.3089 8.8072L15.2351 7.11988ZM11.7073 16.7097L10.3323 15.3347L8.91805 16.7489L10.2931 18.1239L11.7073 16.7097ZM10.2931 16.7097L8.91805 18.0847L10.3323 19.4989L11.7073 18.1239L10.2931 16.7097ZM7.2126 16.4168C6.3789 16.4168 6.06183 15.328 6.76521 14.8804L5.69146 13.1931C3.30002 14.7149 4.37798 18.4168 7.2126 18.4168V16.4168ZM14.7877 5.5835C15.6214 5.5835 15.9385 6.67228 15.2351 7.11988L16.3089 8.8072C18.7003 7.28538 17.6223 3.5835 14.7877 3.5835V5.5835Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15697_5028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapView);
export default __webpack_public_path__ + "static/media/map-view.a73f61ffa0ec15a80ffeadf355c21236.svg";
export { ForwardRef as ReactComponent };